import React, { FC } from 'react';
import './banner.sass';
import { Nullable } from '../../../../shared/types/Typescript-utils';

export interface IBannerProps {
  banner: Nullable<{
    url: string;
    height: number;
  }>;
}

export const Banner: FC<IBannerProps> = ({ banner }) => {
  return (
    banner && (
      <>
        <div className="banner" style={{ backgroundImage: `url(${banner.url})`, height: banner.height }} />
        <div className="banner-top-holder" style={{ height: banner.height }} />
      </>
    )
  );
};

export default Banner;
